var dropdownItemList = 'fx_2d2fb1e5_jzm7hy0';

export { dropdownItemList };
//# sourceMappingURL=itemList.vanilla.mjs.map
